import { createIntegrationConnectionConfigurationClassMixin } from '../../../connection/configuration/IntegrationConnectionConfigurationMixin';

export interface MarianaTekClientConfigurationValid {
    type: 'VALID';
    subdomain: string;
}

export interface MarianaTekClientConfigurationMissing {
    type: 'MISSING_SUBDOMAIN';
}

export type MarianaTekClientConfigurationUnion = MarianaTekClientConfigurationMissing
    | MarianaTekClientConfigurationValid;

export class MarianaTekClientConfiguration extends createIntegrationConnectionConfigurationClassMixin<
    MarianaTekClientConfigurationUnion,
    'MARIANA_TEK_CLIENT'
>('MARIANA_TEK_CLIENT') { }
